import React from "react";
import { AppsOutlined } from '@mui/icons-material';
import { HeaderModule } from "../../components/home/HeaderModule";
import { useModules } from "../../hooks/turns/useModules";
import { TableModule } from "../../components/home/TableModule";
import { ActionsBar } from "../../components/ActionsBar";
import { useLocation } from "react-router-dom";

export const Modules = () => {

    const { columns, modules, addModule } = useModules();
    const location = useLocation();

    return (
        <>
            <HeaderModule
                 icon={<AppsOutlined htmlColor="rgba(0, 0, 0, .6)" />}
                 title="Módulos"
            />

            <ActionsBar 
                addAction={ addModule }
                father='modulos'
                module={ modules[0]?.sede?.nombre }
            />  

            <TableModule 
                columns={ columns }
                rows={ modules }
                styles={{
                    background: '#fff',
                    borderRadius: 6,
                    marginTop: 10,
                }}
            />
        </>
    )
}